import React, { useEffect, useState, useRef } from "react";
import { IconButton, Button, Grow, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Container, FormControl, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import { getAssemblyResponsibles, getServiceOrder, saveServiceOrder, getServiceOrderPlanned, saveServiceOrderPlanned } from "../../store/actions/OrderFormActions";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import { ArrowBackIos } from "@mui/icons-material";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";

let isBreakdown = false;
let isPlanned = false;
export default function OrderForm(props) {
    const { t } = useTranslation("translation");
    const [turkish, setTurkish] = useState(false);

    const [userID, setUserID] = useState();
    const dispatch = useDispatch();
    const [rows, setRows] = useState({});
    const [assemblyResponsiblesData, setAssemblyResponsiblesData] = useState([]);
    const [repairedPart, setRepairedPart] = useState("");
    const [assemblyResponsibleName, setAssemblyResponsibleName] = useState("");
    const [information, setInformation] = useState("");
    const [assemblyResponsibles, setAssemblyResponsibles] = useState(0);
    const taskId = parseInt(new URLSearchParams(props.location.search).get("id"));
    let componentRef = useRef();

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(parseInt(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "")));
        setRows(props.location.state);
        setDefaultStates();
        isBreakdown = new URLSearchParams(props.location.state).get("breakdownDetail");
        isPlanned = new URLSearchParams(props.location.state).get("plannedMaintenance");
        LoadHandler();
    }, []);

    const setDefaultStates = () => {
        setRepairedPart("");
        setAssemblyResponsibleName("");
        setInformation("");
        setAssemblyResponsibles(0);
    };

    const LoadHandler = () => {
        LocalLanguage();
        if (isBreakdown) {
            dispatch(getServiceOrder(taskId));
        } else {
            dispatch(getServiceOrderPlanned(taskId));
        }
        dispatch(getAssemblyResponsibles());
    };

    const LocalLanguage = () => {
        if (localStorage.getItem("i18nextLng") == "tr-TR") {
            setTurkish(true);
        }
    };

    const { assemblyResponsiblesList, serviceOrderList } = useSelector(({ OrderForm }) => OrderForm);

    useEffect(() => {
        if (assemblyResponsiblesList?.resultObject) {
            setAssemblyResponsiblesData(assemblyResponsiblesList.resultObject);
        }
        if (serviceOrderList?.resultObject && Object.keys(serviceOrderList?.resultObject).length > 0) {
            let value = 1;
            if (serviceOrderList.resultObject.length > 1) {
                value = serviceOrderList.resultObject?.length;
            }
            setRepairedPart(serviceOrderList.resultObject[value - 1].piece);
            setInformation(serviceOrderList.resultObject[value - 1].info);
            setAssemblyResponsibleName(turkish ? serviceOrderList.resultObject[value - 1].vendorNameTR : serviceOrderList.resultObject[value - 1].vendorNameEN);
            setAssemblyResponsibles(serviceOrderList.resultObject[value - 1].vendorId);
        }
    }, [assemblyResponsiblesList, serviceOrderList]);

    //set assemblyResponsibles
    const HandleAssemblyResponsibles = (assemblyId) => {
        if (assemblyId != null) {
            const filteredAssembly = assemblyResponsiblesData.filter((item) => (turkish ? item.nameTR.includes(assemblyId) : item.nameEN.includes(assemblyId)));
            setAssemblyResponsibles(filteredAssembly[0].id);
            setAssemblyResponsibleName(turkish ? filteredAssembly[0].nameTR : filteredAssembly[0].nameEN);
            return filteredAssembly[0].id;
        } else {
            setAssemblyResponsibles(null);
            setAssemblyResponsibleName("");
        }
    };

    const HandleRepairedPart = (event) => {
        setRepairedPart(event.target.value);
    };

    const HandleInformation = (event) => {
        setInformation(event.target.value);
    };

    const SubmitHandler = () => {
        if (isBreakdown) {
            const data = {
                taskId: taskId,
                piece: repairedPart,
                info: information,
                vendorId: assemblyResponsibles ? assemblyResponsibles : 0,
            };
            dispatch(saveServiceOrder(data));
        } 
        if (isPlanned) {
            const data = {
                taskId: taskId,
                piece: repairedPart,
                info: information,
                vendorId: assemblyResponsibles ? assemblyResponsibles : 0,
            };
            dispatch(saveServiceOrderPlanned(data));
        }
    };

    //go breakdown detail page
    const BackToBreakdownDetailPage = () => {
        props.history.goBack();
    };

    return (
        <Container maxWidth="sm">
            <div ref={(el) => (componentRef = el)}>
                <Grid id="bd_grid" container alignItems="center">
                    <Grid id="bd_grid_1" item xs={1}>
                        <IconButton id="bd_iconBtn" onClick={BackToBreakdownDetailPage} size="large">
                            <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="end" />
                        </IconButton>
                    </Grid>
                    <Grid id="bd_grid_2" item xs={11}>
                        <Typography id="bd_typ" variant="h6" gutterBottom style={{ fontSize: 20 }}>
                            {props.title} {t("OrderForm")}{" "}
                        </Typography>
                    </Grid>
                </Grid>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer component={Paper}>
                        <Table style={{ width: "100%", tableLayout: "auto" }} aria-label="simple table">
                            <TableBody>
                                <React.Fragment>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("TaskNo")}</b>
                                        </TableCell>
                                        <TableCell id="of_TaskNo" component="th" scope="row" width="50%">
                                            {taskId}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("CallNumber")}</b>
                                        </TableCell>
                                        <TableCell id="of_CallNumber" component="th" scope="row" width="50%">
                                            {rows.maintenanceOrderId}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("EquipmentName")}</b>
                                        </TableCell>
                                        <TableCell id="of_EquipmentName" component="th" scope="row" width="50%">
                                            {rows.equipmentName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("CreatedDate")}</b>
                                        </TableCell>
                                        <TableCell id="of_CreatedDate" component="th" scope="row" width="50%">
                                            {rows.createdDate}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("Assigned")}</b>
                                        </TableCell>
                                        <TableCell id="of_AssigneeName" component="th" scope="row" width="50%">
                                            {rows.assigneeName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("Area")}</b>
                                        </TableCell>
                                        <TableCell id="of_Area" component="th" scope="row" width="50%">
                                            {rows.areaGroupName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("BreakdownGroup")}</b>
                                        </TableCell>
                                        <TableCell id="of_BreakdownGroup" component="th" scope="row" width="50%">
                                            {rows.breakdownGroupName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("CostCenter")}</b>
                                        </TableCell>
                                        <TableCell id="of_BreakdownGroup" component="th" scope="row" width="50%">
                                            {rows.costCenterCode}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("CallNote")}</b>
                                        </TableCell>
                                        <TableCell id="of_CallNote" component="th" scope="row" width="50%">
                                            {rows.notes}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("RepairedPart")}</b>
                                        </TableCell>
                                        <TableCell component="th" scope="row" width="50%">
                                            <TextField id="of_textFiled_1" defaultValue={repairedPart ? repairedPart : ""} onChange={HandleRepairedPart} variant="outlined" multiline />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("Information")}</b>
                                        </TableCell>
                                        <TableCell component="th" scope="row" width="50%">
                                            <TextField id="of_textFiled_2" defaultValue={information ? information : ""} onChange={HandleInformation} variant="outlined" multiline />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="50%">
                                            <b>{t("Repairman")}</b>
                                        </TableCell>
                                        <TableCell component="th" scope="row" width="50%">
                                            <FormControl style={{ width: "100%" }} variant="outlined">
                                                <Autocomplete
                                                    id="of_autocomplete"
                                                    value={assemblyResponsibleName}
                                                    style={{ marginTop: -15 }}
                                                    onChange={(event, newValue) => {
                                                        HandleAssemblyResponsibles(newValue);
                                                    }}
                                                    options={assemblyResponsiblesData.map((option) => (turkish ? option.nameTR : option.nameEN))}
                                                    renderInput={(params) => <TextField id="of_textFiled_1" {...params} label={t("Repairman")} margin="normal" variant="outlined" />}
                                                />
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grow>
            </div>
            <div style={{ margin: 20 }}>
                <Button id="of_button" onClick={() => SubmitHandler()} variant="contained" color="primary">
                    {t("Save")}
                </Button>
                <ReactToPrint
                    trigger={() => {
                        return (
                            <IconButton id="of_button_2" color="primary" aria-label="download table" component="label" style={{ marginLeft: 30 }}>
                                <PrintIcon fontSize="large" />
                            </IconButton>
                        );
                    }}
                    content={() => componentRef}
                    pageStyle="print"
                />
            </div>
            <LoadingBackdrop id="of_lbd" />
        </Container>
    );
}
